import React, { Component, FunctionComponent } from 'react';
import { Grid, Chip, Grow, Typography, Paper, useTheme } from '@material-ui/core'
import ChipLabel from './ChipLabel';
import { SearchFilter, CategoryFilter, PropertyFilter, ANY_PROP_OPTION } from '../../models/SearchFilter';
import { IMAGES_URL } from '../../api/client';
import ProductProperties from './ProductProperties/ProductProperties';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { roundedCorners } from '../../QmoTheme';
import { ProductProp } from '../../models/ProductProp';


type Props = {
    appliedFilters: CategoryFilter[]
    filtersToPick: CategoryFilter[],
    applyFilter: (filter: SearchFilter) => void,
    removeFilter: (filter: SearchFilter) => void,
    isBusy: boolean,
    replaceFilter: (categoryFilter?: CategoryFilter | null, propertyFilter?: PropertyFilter| null) => void,
    appliedPropertyFilters: PropertyFilter[],
    currentProductProperties: ProductProp[]
}

const gradientStyle = (image: string, showBackgroundImg: boolean) => {
    if (showBackgroundImg)
        return {
            backgroundImage: 'linear-gradient(to right, rgba(255,255,255,1) 78%,rgba(255,255,255,0)),url(' + IMAGES_URL + image + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: 'contain'
        }
    else return {}
}


type FiltersBackgroundProps = {
    image: string
}
const FiltersBackground: FunctionComponent<FiltersBackgroundProps> = ({ image, children }) => {
    let theme = useTheme()
    let aboveXS = useMediaQuery(theme.breakpoints.up("sm"))

    return (<Paper style={Object.assign({}, { width: '100%', padding: "14px", minHeight: '160px' }, gradientStyle(image, aboveXS), roundedCorners)} >{children}</Paper>)
}


class SearchFilters extends Component<Props> {

    render() {
        let currentFilter = this.props.appliedFilters.length > 0 ? this.props.appliedFilters[this.props.appliedFilters.length - 1] : null

        return (
            <div>
                {this.props.filtersToPick &&
                    <Grid container alignItems="center" alignContent="center" style={{ textAlign: "center" }}>
                        {currentFilter !== null &&

                            <FiltersBackground image={currentFilter.taxonomyReference!.orderSheetImage ? currentFilter.taxonomyReference!.orderSheetImage : currentFilter.taxonomyReference!.image}>
                                <Grid item xs={12} sm={12} style={{ textAlign: "left" }}>
                                    {this.props.appliedFilters.map((f, i) => {
                                        return (
                                            <div key={i} style={{ display: 'inline-block' }}>

                                                {i !== 0 &&
                                                    <div style={{ padding: '6px 0 6px 0', display: "inline-block" }}>
                                                        <Typography variant="body1" style={{ display: "inline-block", fontWeight: 'bold' }}>&nbsp;{'>'}&nbsp;</Typography>
                                                    </div>
                                                }

                                                <div style={{ padding: '6px 0 6px 0', display: "inline-block" }}>
                                                    <Typography onClick={
                                                        (e) => {
                                                            for (let j = this.props.appliedFilters.length - 1; j > i; j--)
                                                                this.props.removeFilter(this.props.appliedFilters[j])
                                                        }}
                                                        variant="body1" style={{ display: "inline-block", cursor: 'pointer' }}>{f.value.toString()}</Typography>
                                                </div>

                                            </div>
                                        )
                                    })}
                                    <Grid container alignItems="flex-end">
                                        <Grid item>
                                            <div style={{ display: "inline-block" }}><Typography style={{ fontWeight: "bold" }} variant="h2">{this.props.appliedFilters[this.props.appliedFilters.length - 1].value.toString()}</Typography></div>
                                        </Grid><Grid item>
                                            <div style={{ display: "inline-block" }}><Chip color="primary" style={{ fontWeight: "bold" }} label={this.props.appliedFilters[this.props.appliedFilters.length - 1].count || 0}></Chip></div>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {this.props.filtersToPick.length > 0 && this.props.filtersToPick.map(f => (f.count ? f.count : 0)).reduce((a, b) => a + b, 0) > 0 &&
                                    <div>
                                        <Grid item xs={12} sm={12} style={{ textAlign: "left", padding: "5px 0 0 0" }}>
                                            <Typography variant="subtitle1">SUBCATEGORIES</Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12} style={{ textAlign: "left" }}>
                                            {(this.props.filtersToPick).map((f, i) => {
                                                let isApplied: boolean = this.props.appliedFilters.find((fi) => fi.id === f.id) !== undefined
                                                return (
                                                    <div key={i} style={{ display: 'inline-block' }}>
                                                        {f.count! > 0 && !this.props.isBusy &&
                                                            <div style={{ padding: '6px' }}>
                                                                <Grow in={true} appear={true}>
                                                                    <Chip
                                                                        label={<ChipLabel label={f.value.toString()} quantity={f.count || 0} />}
                                                                        onClick={() => isApplied ? this.props.removeFilter(f) : this.props.applyFilter(f)}
                                                                        //color={isApplied ? "primary" : "default"}
                                                                        color="primary"
                                                                        style={{ padding: '5px' }}
                                                                    />
                                                                </Grow>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </Grid>
                                    </div>
                                }
                            </FiltersBackground>
                        }

                    </Grid>
                }
            </div>
        );
    }
}

export default SearchFilters;